module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    class: ("progress__bar" + (_vm.isHidden ? ' progress__bar--hidden' : ''))
  }, [_c('div', {
    staticClass: "progress__bar__amount",
    style: (("width: " + (_vm.progress == 0 ? 1 : _vm.progress) + "%"))
  }), _vm._v(" "), (!_vm.isHidden) ? _c('div', {
    staticClass: "progress__bar__details"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('progressBar.percentageComplete', {
    progress: _vm.progress
  })) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eeaed32","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 1050
// module chunks = 1